(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-scrolling-cards"] && !Shopify.designMode) return;
  try {
    
  // scroll container horizontally
  function scrollHorizontally(element, direction) {

    if (direction == 0) {
      element.scroll({
        left: element.scrollLeft - 350,
        behavior: 'smooth'
      })
    }
    else {
      element.scroll({
        left: element.scrollLeft + 350,
        behavior: 'smooth'
      })
    }
  }


  // listen for click on scroll arrows
  var scrollArrowButtons = document.getElementsByClassName("js:scrollArrowButtons");
  Array.from(scrollArrowButtons).forEach(function(scrollArrowButton) {
    scrollArrowButton.addEventListener('click', function(e){
      let scrollContainerClass = this.getAttribute('data-scroll-container');
      let scrollDirection = this.getAttribute('data-scroll-direction');
      var scrollContainers = document.getElementsByClassName(scrollContainerClass);
      Array.from(scrollContainers).forEach(function(scrollContainer) {
        scrollHorizontally(scrollContainer, scrollDirection);
      });
    });
  });

  /*
  //Hide scroll arrows if number of items is less than 5
  var scrollItemLength = document.querySelectorAll(".section__scrollbox, .scrollbox__item").length;
  if (scrollItemLength < 5) {
    for (var i = 0; i < scrollItemLength; i++) {
      //console.log(scrollArrowButtons[i]);
      scrollArrowButtons[i].style.visibility = "hidden";
      //scrollArrowButtons[i].style.display = "none";
    }
  }
  */

  } catch(e) { console.error(e); }
})();
})();
